import { RootState } from "@/store/store";
import { normalizedCostWidgetByIdSelector } from "@/store/dashboards/selectors/widgets/normalized-cost-widget/widget-view/normalizedCostWidgetByIdSelector";
import { WidgetTitleProps } from "@/components/pages/dashboard/utils/types/types";
import { resourceExplorerViewNameByViewIdSelector } from "@/store/resource-explorer/selectors/all-resource-explorers/resourceExplorerViewNameByViewIdSelector";
import { objectToUrl } from "@/components/utils/helpers/dataToUrlToDataConvertors";
import { currentDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/currentDashboardIdSelector";
import { dashboardDimensionsCategoryIdsByDashboardIdSelector } from "@/store/dashboards/selectors/dashboard/filters/dashboardDimensionsCategoryIdsByDashboardIdSelector";

export const normalizedCostWidgetTitlePropsByIdSelector = (
  state: RootState,
  widgetId: string,
): WidgetTitleProps => {
  const widget = normalizedCostWidgetByIdSelector(state, widgetId);
  const viewName = resourceExplorerViewNameByViewIdSelector(
    state,
    widget?.view_id ?? undefined,
  );

  const path = objectToUrl([
    {
      forecastOption: widget?.forecast_option,
      dates: widget?.dates,
      dateGranularity: "monthly",
      chartType: widget?.visualization?.chart_type ?? "line",
      filterTree: undefined,
    },
  ]);

  const dashboardId = currentDashboardIdSelector(state);

  const dimensionCategoryIds =
    dashboardDimensionsCategoryIdsByDashboardIdSelector(
      state,
      dashboardId ?? "",
    );

  let url = `/resource-explorer/${widget?.view_id}?path=${path}`;

  if (dimensionCategoryIds?.dimension_id && dimensionCategoryIds?.category_id) {
    url = `${url}&categoryId=${dimensionCategoryIds?.category_id}&dimensionId=${dimensionCategoryIds?.dimension_id}`;
  }

  return {
    widgetName: widget?.name ?? "",
    dates: widget?.dates ?? {},
    sourceData: { title: viewName ?? "", url },
  };
};
